import React from 'react';

import {withUser} from '../lib/user';
import * as api from '../lib/api';
import * as actions from '../state/actions';

class LabelWatcher extends React.Component {
  state = {
    failureCount: 0
  };

  async componentDidMount() {
    const {credentials} = this.props;
    const labelLinks = await api.getLabelLinks(credentials);
    await this.lookupLabels(labelLinks);
    const watcherId = setInterval(() => this.looper(), 10 * 60 * 1000);
    this.setState({labelLinks, expiration: new Date(Date.now() + 12 * 60 * 60 * 1000), watcherId});
  }

  componentWillUnmount() {
    clearInterval(this.state.watcherId);
  }

  async looper() {
    const {credentials} = this.props;
    const {labelLinks, expiration} = this.state;
    let links = labelLinks;
    let exp = expiration;
    try {
      if (!links || Date.now() > expiration.getTime()) {
        links = await api.getLabelLinks(credentials);
        exp = new Date(Date.now() + 12 * 60 * 60 * 1000);
      }
      await this.lookupLabels(links);
      this.setState({labelLinks: links, expiration: exp});
    }
    catch (e) {
      console.error("Couldn't lookup links");
    }
  }

  async lookupLabels(links) {
    const {dispatch} = this.props;
    try {
      const labels = await api.getLabels(links.labels);
      dispatch(actions.updateCompanySettings(labels));
    }
    catch (errorResponse) {
      if (errorResponse.status === 404) {
        dispatch(actions.updateCompanySettings({}));
      }
      else {
        this.setState({labelLinks: "", expiration: null});
      }
    }

    const logoStatus = await api.getCompanyLogoStatus(links.logo);
    if (logoStatus < 300) {
      dispatch(actions.updateCompanyLogo(links.logo));
    }
    else if (logoStatus === 404) {
      dispatch(actions.updateCompanyLogo(null));
    }
    else {
      this.setState({labelLinks: "", expiration: null});
    }
  }

  render() {
    return null;
  }
}

export default withUser(LabelWatcher);